<template>
  <div class="nx-upload">
    <template v-if="type === 'image'">
      <div
        v-for="(file, index) in showFileList"
        :key="index"
        class="nx-upload--file"
        :style="showOnList?showOnListStyle:{}"
        @click="handlePreview(file, index)"
      >
        <img
          class="nx-upload__img"
          style="color: #ccc"
          :src="file.path || file"
          alt="加载失败"
        />
        <div v-if="canOperate" class="nx-upload__delete">
          <i class="el-icon-delete" @click.stop="handleRemove(index)"></i>
        </div>
      </div>
    </template>
    <template v-if="type === 'video'">
      <div
        v-for="(file, index) in showFileList"
        :key="index"
        class="nx-upload--video"
      >
        <div v-if="canOperate" class="nx-upload__delete">
          <i class="el-icon-delete" @click.stop="handleRemove(index)"></i>
        </div>
        <video controls style="height: 200px" :src="file"></video>
      </div>
    </template>
    <template v-if="type === 'pdf'">
      <div
        v-for="(file, index) in showFileList"
        :key="index"
        class="nx-upload--file"
        style="width: auto; height: auto; padding: 0 30px"
      >
        <!-- name 文件名、path 文件路径 -->
        {{ file.name }}
        <div v-if="canOperate" class="nx-upload__delete">
          <i class="el-icon-delete" @click.stop="handleRemove(index)"></i>
        </div>
        {{ `${fileName}` }}
      </div>
    </template>
    <el-upload
      v-if="
        fileData.length < (Array.isArray(fileData) ? limit : 1) && canOperate
      "
      v-loading="isLoading"
      :multiple="multiple"
      :element-loading-text="`${(progress * 100).toFixed(2)}%`"
      class="nx-upload--operation"
      :limit="Array.isArray(fileData) ? limit : 1"
      auto-upload
      :show-file-list="false"
      :file-list="showFileList"
      :http-request="httpRequest"
      :on-error="onError"
      :accept="accept"
      action=""
    >
      <i slot="default" class="el-icon-plus nx-upload_icon"></i>
      <div class="nx-tips__text">
        <slot></slot>
      </div>
    </el-upload>
  </div>
</template>
<script>
import { uploadFile } from '@/utils/upload';
import { isVideo, isImage, isPdf } from '@/utils/validate';
import { deepClone } from '@/utils';
export default {
  name: 'BjUpload',
  model: {
    prop: 'fileData',
    event: 'onFileChange'
  },
  props: {
    // 是否可操作
    canOperate: {
      type: Boolean,
      default: () => true
    },
    type: {
      type: String,
      default: () => 'image',
      validator: function(value) {
        return ['image', 'video', 'pdf'].includes(value);
      }
    },
    accept: {
      type: String,
      default: () => ''
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    // 作为非图片/视频类文件的展示名称
    fileName: {
      type: String,
      default: () => ''
    },
    // 文件上传最大数量
    limit: {
      type: Number,
      default: () => 9
    },
    // 文件大小限制
    size: {
      type: [Number, String],
      default: () => ''
    },
    duration: {
      type: Number,
      default: () => 5 * 60
    },
    fileData: {
      type: [Array, String, Object],
      require: true,
      default: () => ''
    },
    // 是否检查文件是否合法
    check: {
      type: Boolean,
      default: true
    },
    // 上传文件的正则验证
    reg: {
      type: [RegExp, String],
      default: () => ''
    },
    //
    uploadingType: {
      type: [Number, String],
      default: () => ''
    },
    // 是否需要返回文件名称
    isFileName: {
      type: Boolean,
      default: false
    },
    // 是否是在列表展示
    showOnList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 用于展示的数组，保持数据的一致性
      showFileList: [],
      isLoading: false,
      progress: 0,
      videoInfo: {},
      showOnListStyle: {
        border: 'none',
        margin: 0
      }
    };
  },
  computed: {
    // ...mapGetters(['global'])
  },
  watch: {
    fileData: {
      immediate: true,
      handler(fileData) {
        if (Array.isArray(fileData)) {
          this.showFileList = deepClone(fileData);
        }
        else {
          this.showFileList = [];
          if (this.fileData) {
            this.showFileList.push(this.fileData);
          }
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    async httpRequest(req) {
      const { onError, file } = req;
      const isPass = await this.beforeUpload(file, onError);
      if (!isPass) {
        req.file = null;
        onError();
        return;
      }
      this.isLoading = true;
      const path = await this.uploadFile(file, onError);
      let obj = path;
      if (this.type === 'pdf' || this.isFileName) {
        // 需要返回文件名称
        obj = { path, name: file.name };
        if (this.type === 'pdf') {
          obj = { ...obj, size: file.size };
        }
      }
      this.onSuccess(path, obj);
    },
    async uploadFile(file, onError) {
      const config = await uploadFile(file, this.type);
      return config.url;
    },
    async beforeUpload(file, onError) {
      const map = {
        image: this.checkImage,
        video: this.checkVideo,
        pdf: this.checkPdf
      };
      if (this.reg && !this.reg.test(file.name.toLowerCase())) {
        onError('选择的文件格式不正确，请重新上传');
        return false;
      }
      if (this.size && file.size > this.size * 1024 * 1024) {
        onError(`文件大小不能超过${this.size}M`);
        return false;
      }
      const isPass = await map[this.type](file, onError);
      return isPass;
    },
    onError(msg) {
      this.isLoading = false;
      this.$message.error(msg || '文件上传失败，请检查网络连接后重试');
    },
    onSuccess(res, file) {
      this.isLoading = false;
      if (Array.isArray(this.fileData) && this.fileData.length < this.limit) {
        this.fileData.push(file);
        this.$emit('onFileChange', this.fileData);
      }
      else {
        this.$emit('onFileChange', file);
      }
    },
    /**
     * 图片上传前验证
     */
    checkImage(file, onError) {
      return new Promise(async(resolve) => {
        if (!this.reg && !isImage(file.name)) {
          onError('选择的文件格式不正确，请重新上传!');
          return resolve(false);
        }
        resolve(true);
      });
    },
    /**
     * 视频上传前验证
     */
    checkVideo(file, onError) {
      return new Promise(async(resolve) => {
        if (!this.reg && !isVideo(file.name)) {
          onError('选择的文件格式不正确，请重新上传!');
          return resolve(false);
        }
        const videoInfo = await this.getVideoInfo(file);
        console.log(videoInfo);
        if (this.duration && videoInfo.duration > this.duration) {
          onError(`视频长度不能超过${this.duration}秒!`);
          return resolve(false);
        }
        const coverFile = this.baseUrlToFile(
          videoInfo.coverPic,
          `${file.name}.jpg`
        );
        const uploadResult = await this.uploadFile(coverFile, onError);
        this.$emit('videoInfo', {
          duration: videoInfo.duration,
          url: `https://${uploadResult.Location}`,
          size: (file.size / 1024 / 1024).toFixed(2)
        });
        /**
         * TODO 上传封面图
         */
        resolve(true);
      });
    },
    checkPdf(file, onError) {
      return new Promise(async(resolve) => {
        if (!isPdf(file.name)) {
          onError('选择的文件格式不正确，请重新上传!');
          return resolve(false);
        }
        resolve(true);
      });
    },
    // 获取视频长度，提取封面图
    getVideoInfo(file) {
      const url = URL.createObjectURL(file);
      return new Promise((resolve) => {
        let dataURL = '';
        const video = document.createElement('video');
        video.setAttribute('crossOrigin', 'anonymous');
        video.setAttribute('src', url);
        video.setAttribute('autoplay', 'autoplay');
        video.setAttribute('width', 400);
        video.setAttribute('height', 240);
        video.setAttribute('muted', 'true');
        document.body.appendChild(video);
        video.addEventListener('canplay', (e) => {
          video.setAttribute('width', e.target.videoWidth);
          video.setAttribute('height', e.target.videoHeight);
          const canvas = document.createElement('canvas');
          const width = video.width; // canvas的尺寸和图片一样
          const height = video.height;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(video, 0, 0, width, height); // 绘制canvas
          dataURL = canvas.toDataURL('image/jpeg'); // 转换为base64
          document.body.removeChild(video);
          resolve({
            duration: video.duration,
            coverPic: dataURL
          });
        });
        video.addEventListener('loadeddata', () => {
          console.log('loadeddata');
          video.muted = true;
        });
      });
    },
    baseUrlToFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleRemove(index) {
      if (Array.isArray(this.fileData)) {
        this.fileData.splice(index, 1);
        this.$emit('onFileChange', this.fileData);
      }
      else {
        this.$emit('onFileChange', '');
      }
    },
    handlePreview(sources, activeIndex) {
      if (!Array.isArray(sources)) {
        sources = [sources];
      }
      this.$preview({
        sources,
        activeIndex
      });
    },
    splitFileName(file) {
      // 截取文件后缀名
      const fileName = file.lastIndexOf('.'); // 取到文件名开始到最后一个点的长度
      const fileNameLen = file.length; // 取到文件名长度
      const fileType = file.substring(fileName + 1, fileNameLen);
      return fileType;
    }
  }
};
</script>
<style lang="less">
  .nx-upload--operation {
    .el-upload {
      width:100%;
      height: 100%;
    }
  }
</style>
<style lang="less" scoped>
.nx-tips__text {
  margin: 0 20px;
  line-height: 16px;
  margin-top: 20px;
}
.nx-upload {
  display: flex;
  flex-wrap: wrap;
  .nx-upload--operation,
  .nx-upload--file {
    position: relative;
    width: 148px;
    height: 148px;
    border: 1px dashed #c0ccda;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 6px;
    .nx-upload__img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .nx-upload__delete {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    z-index: 99;
    height: 0;
    border-top: 30px solid #409eff;
    border-left: 30px solid transparent;
    cursor: pointer;
    i {
      position: absolute;
      top: -27px;
      left: -15px;
    }
  }
  .el-upload {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .nx-upload--video {
    position: relative;
    width: 100%;
    height: auto;
  }
  .nx-upload_icon{
    width: 148px;
    height:148px;
    display:flex;
    align-items:center;
    justify-content:center
  }
}
</style>
